/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

/**
 * BORROWED CODE
 *
 * Duplicated and modified from the equivalent component
 * on the case study landing page:
 * views/case-studies-landing/components/hero/featured-case-study/index.tsx
 * - Changed: Converted to showcase any featured press item
 * - Added: Props for featuredImage, eyebrow
 */

import { Link } from 'lib/i18n/routing'
import Image from 'next/image'
import ExpandableArrow from 'components/expandable-arrow'
import { useHover } from '@web/hooks/use-hover'
import s from './style.module.css'

interface FeaturedPressItemImage {
	url: string
	width?: number
	height?: number
}

export interface FeaturedPressItemProps {
	featuredImage?: FeaturedPressItemImage
	eyebrow: string
	title: string
	url: string
}

export default function FeaturedPressItem({
	featuredImage,
	eyebrow,
	title,
	url,
}: FeaturedPressItemProps) {
	const [hoverRef, isHovered] = useHover<HTMLAnchorElement>()

	return (
		<article className={s.featuredPressItem}>
			<div className={s.image}>
				<Image
					src={featuredImage.url}
					alt=""
					width={featuredImage.width}
					height={featuredImage.height}
					aria-hidden="true"
				/>
			</div>

			<Link ref={hoverRef} href={url} passHref className={s.link}></Link>

			<div className={s.content}>
				<p className={s.eyebrow}>{eyebrow}</p>

				<h2 className={s.title}>{title}</h2>

				<div className={s.pseudoCta}>
					Read article{' '}
					<ExpandableArrow className={s.pseudoCtaArrow} expanded={isHovered} />
				</div>
			</div>
		</article>
	)
}
